// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Service_wrapper__3b0t8","block":"Service_block__3ywmj","list":"Service_list__1DueV"};